import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function AutoInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { autoInsurancePossessed: autoInsurancePossessed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('have_auto_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader header="Do you have auto insurance?" />
      <Formik
        initialValues={{ autoInsurancePossessed }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema('autoInsurancePossessed')}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator name="autoInsurancePossessed" />

          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { AutoInsuranceStep };
